import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";
import type {
  JournalEntryDto,
  JournalEntryFilter,
} from "@/features/ledger/api/dto";

/**
 * Journal comptable paginé (`POST /JournalEntries/all`, guide §4.2) —
 * filtrable par code produit, service émetteur, référence source, statut
 * et date de valeur. Lecture authentifiée : `mutateData` en queryFn.
 */
export const useJournalEntries = (
  params: ListRequest<JournalEntryFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.LEDGER_JOURNAL_ENTRIES_LIST(params),
    queryFn: () =>
      mutateData({
        url: ledgerEndpoints.journalEntries.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<JournalEntryDto>>,
    enabled,
  });
